import { Stack, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import StockFilter from "./StockFilter";

const Filters = (props) => {
  return (
    <div style={{ width: "100%" }}>
      <div style={{ display: "flex", flexDirection: "row",flexWrap: 'wrap' }}>
        {props.data.map((filter, index) => {
          return (
            <div key={index} style={{ display: 'flex', flexDirection: 'row', marginTop: '10px', marginRight: '10px', width: '700px', alignItems: 'center' }}>
              <Typography style={{ width: '200px', marginRight: '10px' }}>{filter["name"]}</Typography>
              <StockFilter data={filter["items"]} name={filter["name"]} label={filter["label"]} />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Filters;
